import { useAtom, useAtomValue } from "jotai";
import { isDarkModeAtom, applyDarkModeAtom } from "./atoms";

/**
 * Hook to get and toggle dark mode
 */
export function useDarkMode() {
  const isDark = useAtomValue(isDarkModeAtom);
  const [, applyDarkMode] = useAtom(applyDarkModeAtom);

  const toggleDarkMode = () => {
    applyDarkMode(!isDark);
  };

  return {
    isDark,
    toggleDarkMode,
  };
}

